import React from 'react'

import {
  Page,
  Typography,
} from '@probatix/common/components/atoms'
import Card from 'react-bootstrap/Card'
import { Container } from 'react-bootstrap'

const TemporarySolutionView: React.FC = () => (
  <Page>
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Card
        className="text-center shadow"
        style={{ border: "2px solid #dee2e6", maxWidth: "500px" }}
      >
        <Card.Body>
          <Card.Text className="fs-2 my-2">
            <Typography
              align="center"
              fontSize="1rem"
            >
              <b>Wir haben aktuell ein Problem festgestellt und arbeiten bereits an einer Lösung.</b> <br/>
              Bitte versuchen Sie es in Kürze erneut und rufen Sie diese Seite später noch einmal auf.
            </Typography>
          </Card.Text>
        </Card.Body>
      </Card>
    </Container>
  </Page>
)

export default TemporarySolutionView
